import { create } from 'zustand';

export interface IErrorResponse {
  code?: string;
  errors?: string[];
}

export interface UseErrorStoreInterface {
  code?: string;
  showError: boolean;
  message: string | undefined;
  setShowError: (response: IErrorResponse) => void;
  setCloseError: () => void;
}

export const useErrorStore = create<UseErrorStoreInterface>((set) => ({
  code: undefined,
  showError: false,
  message: undefined,
  setShowError: ({ code, errors }: IErrorResponse) => {
    let errorMessage: string | undefined;

    if (errors && errors?.length > 0) {
      errorMessage = errors[0];
    }

    return set(() => ({
      code,
      showError: true,
      message: errorMessage,
    }));
  },
  setCloseError: () =>
    set(() => ({
      code: undefined,
      showError: false,
      message: undefined,
    })),
}));
